export const dev_baseUrl = process.env.REACT_APP_API_URL || 'https://stagingapi.cleri.ai/api';

